import { Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/common/i18n';
// language list
import { locale as enLang } from './modules/common/i18n/vocabs/en';
import { locale as chLang } from './modules/common/i18n/vocabs/ch';
import { locale as esLang } from './modules/common/i18n/vocabs/es';
import { locale as jpLang } from './modules/common/i18n/vocabs/jp';
import { locale as deLang } from './modules/common/i18n/vocabs/de';
import { locale as frLang } from './modules/common/i18n/vocabs/fr';
import { vi_VN, NzI18nService, en_US, zh_CN } from 'ng-zorro-antd/i18n';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private i18n: NzI18nService,
    private translate: TranslateService
  ) {
    // register translations
    this.translationService.loadTranslations(
      // enLang,
      // chLang,
      esLang,
      // jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.i18n.setLocale(vi_VN);
    this.translate.setDefaultLang('vi');
    this.translate.use('vi');
  }
}
